import axiosBackend from '../axiosBackend'

export function getLoggedUser (params) {
  // console.log('getLoggedUser (params): ', params)
  // .get('/myself', communitySlug && communitySlug != 'my' ? { params: { communitySlug } } : '');
  return axiosBackend.get('/myself', { params })
}